/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import { Button, Icon } from '@chakra-ui/react';
import { HiOutlineArrowDownTray } from 'react-icons/hi2';

export const DownloadCSV = ({ url, isLoading, isError }: { url?: string; isLoading: boolean; isError?: boolean }) => {
  return (
    <Button
      as="a"
      href={url}
      isDisabled={isError}
      visibility={url ? 'visible' : 'hidden'}
      size={{ base: 'sm', md: 'md' }}
      leftIcon={<Icon as={HiOutlineArrowDownTray} />}
      isLoading={isLoading}
    >
      Download CSV
    </Button>
  );
};
